var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "md",
            title: "Export de synthèse",
            "ok-title": "Exporter",
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            hide: _vm.cacherModalSynthese,
            ok: function($event) {
              return _vm.synthesePortage()
            }
          },
          model: {
            value: _vm.montrerModalSynthese,
            callback: function($$v) {
              _vm.montrerModalSynthese = $$v
            },
            expression: "montrerModalSynthese"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("v-date-picker", {
                  staticClass: "date-picker",
                  attrs: {
                    "is-range": "",
                    columns: 2,
                    step: 1,
                    popover: { visibility: "click" }
                  },
                  on: {
                    input: function($event) {
                      return _vm.changerPeriodeSynthese(
                        $event.start,
                        $event.end
                      )
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var inputValue = ref.inputValue
                        var inputEvents = ref.inputEvents
                        return [
                          _c(
                            "input",
                            _vm._g(
                              {
                                domProps: {
                                  value:
                                    inputValue.start || inputValue.end
                                      ? inputValue.start +
                                        " au " +
                                        inputValue.end
                                      : "Sélectionnez une période"
                                }
                              },
                              inputEvents.start
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.periodeSyntheseSelectionnee,
                    callback: function($$v) {
                      _vm.periodeSyntheseSelectionnee = $$v
                    },
                    expression: "periodeSyntheseSelectionnee"
                  }
                }),
                !_vm.$v.lundiDeLaSemaineOrigine.required ||
                !_vm.$v.dimancheDeLaSemaineOrigine.required
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Ce champ est requis")
                    ])
                  : _vm._e(),
                _c("em", [_vm._v("(4 semaines maximum seront extraites)")])
              ],
              1
            )
          ])
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("BarreFiltres", {
            attrs: { filtres: _vm.filtres },
            on: {
              "appliquer-filtre": function($event) {
                return _vm.appliquerFiltre($event)
              }
            }
          }),
          _c("BarreActions", {
            attrs: { actions: _vm.actions },
            on: {
              "appliquer-action": function($event) {
                return _vm.executerAction($event)
              }
            }
          }),
          _c(
            "div",
            {
              staticClass:
                "card card-minimal table-scroll height-responsive-100"
            },
            [
              _c(
                "table",
                { staticClass: "table table-sm table-bordered table-header" },
                [
                  _c("thead", [
                    _c("th", [
                      _vm._v(
                        "Période du " +
                          _vm._s(
                            _vm.jour && _vm.jour.toLocaleDateString("FR-fr")
                          ) +
                          " au " +
                          _vm._s(
                            _vm.jour &&
                              _vm.getDimancheDeLaSemaine(_vm.jour) &&
                              _vm
                                .getDimancheDeLaSemaine(_vm.jour)
                                .toLocaleDateString("FR-fr")
                          )
                      )
                    ])
                  ])
                ]
              ),
              _c("div", { staticClass: "table-body" }, [
                _c("table", { staticClass: "table table-sm table-bordered" }, [
                  _c("thead", [
                    _c(
                      "tr",
                      { staticStyle: { background: "white" } },
                      [
                        _c("th", [_vm._v("Lieu")]),
                        _c("th", [_vm._v("Menu")]),
                        _c("th", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("Service")
                        ]),
                        _c("th", { staticStyle: { "text-align": "center" } }, [
                          _vm._v("Régime")
                        ]),
                        _c("th", [_vm._v("Texture")]),
                        _c(
                          "th",
                          { attrs: { title: "Présence de plats témoins" } },
                          [_vm._v("T.")]
                        ),
                        _vm._l(
                          _vm.effectifs[0] && _vm.effectifs[0].parJour,
                          function(journee) {
                            return _c(
                              "th",
                              {
                                key: journee.date,
                                staticStyle: { "text-align": "center" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatHumanDate(journee.date)) +
                                    " "
                                )
                              ]
                            )
                          }
                        )
                      ],
                      2
                    )
                  ]),
                  _vm.effectifs.length
                    ? _c(
                        "tbody",
                        { key: _vm.key, ref: "body" },
                        [
                          _vm.enChargement || !_vm.effectifsFiltres[0]
                            ? _c("tr", [
                                _c("td", { attrs: { colspan: "13" } }, [
                                  _vm.enChargement
                                    ? _c("img", {
                                        staticStyle: {
                                          display: "block",
                                          "margin-left": "auto",
                                          "margin-right": "auto"
                                        },
                                        attrs: {
                                          alt: "en attente",
                                          src:
                                            "/assets/images/spinners/cooking-blue-court.gif"
                                        }
                                      })
                                    : _vm._e()
                                ])
                              ])
                            : _vm._l(_vm.effectifsFiltres, function(
                                ligne,
                                iLigne
                              ) {
                                return _c(
                                  "tr",
                                  {
                                    key: iLigne,
                                    style: ligne.structure.actif
                                      ? ""
                                      : "color:lightgrey;font-style:italic;"
                                  },
                                  [
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.nomLieu(ligne)))
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(_vm.nomStructure(ligne)) + " "
                                      ),
                                      ligne.gererParMenu
                                        ? _c("span", [_vm._m(0, true)])
                                        : _vm._e()
                                    ]),
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.nomService(ligne)))
                                    ]),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "font-size": "smaller" }
                                      },
                                      [_vm._v(_vm._s(_vm.nomRegime(ligne)))]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "font-size": "smaller" }
                                      },
                                      [_vm._v(_vm._s(_vm.nomTexture(ligne)))]
                                    ),
                                    _c("td", [
                                      ligne.aPlatTemoin
                                        ? _c("i", {
                                            staticClass: "icone-platTemoin",
                                            staticStyle: {
                                              "font-size": "1.3em",
                                              "text-align": "center"
                                            }
                                          })
                                        : _vm._e()
                                    ]),
                                    _vm._l(ligne.parJour, function(
                                      journee,
                                      iJournee
                                    ) {
                                      return _c(
                                        "td",
                                        {
                                          key: iJournee,
                                          staticStyle: {
                                            "text-align": "center"
                                          }
                                        },
                                        [
                                          journee &&
                                          _vm.lieuOuvert(
                                            ligne.lieuId,
                                            iJournee + 1
                                          )
                                            ? [
                                                ligne.structure.facturables
                                                  ? [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size":
                                                              "smaller"
                                                          },
                                                          attrs: {
                                                            title:
                                                              "Effectif de production"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              journee.effectif
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._l(
                                                        ligne.structure
                                                          .facturables,
                                                        function(
                                                          facturable,
                                                          iFacturable
                                                        ) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key:
                                                                facturable.id,
                                                              staticStyle: {
                                                                "font-size":
                                                                  "smaller"
                                                              },
                                                              attrs: {
                                                                title:
                                                                  facturable.libelle +
                                                                  " sur un total de  " +
                                                                  journee.effectif
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    facturable.id.substring(
                                                                      0,
                                                                      1
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                "InputNumber",
                                                                {
                                                                  class: {
                                                                    parDefaut:
                                                                      journee.id ===
                                                                        0 &&
                                                                      !journee.effectifModifie,
                                                                    nombreModifie:
                                                                      journee.effectifModifie,
                                                                    inputEffectif: true
                                                                  },
                                                                  staticStyle: {
                                                                    width:
                                                                      "22px"
                                                                  },
                                                                  attrs: {
                                                                    typeFiltre:
                                                                      "quantiteEntiere",
                                                                    "data-key":
                                                                      journee.key +
                                                                      "-" +
                                                                      facturable.id,
                                                                    disabled:
                                                                      _vm.enEnregistrement ||
                                                                      _vm.enChargement ||
                                                                      !ligne
                                                                        .structure
                                                                        .actif
                                                                  },
                                                                  on: {
                                                                    move: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.moveEffectif(
                                                                        $event,
                                                                        iLigne,
                                                                        iJournee,
                                                                        iFacturable
                                                                      )
                                                                    },
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.inputEffectif(
                                                                        $event,
                                                                        ligne,
                                                                        journee
                                                                      )
                                                                    }
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      journee
                                                                        .details[
                                                                        facturable
                                                                          .id
                                                                      ],
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        journee.details,
                                                                        facturable.id,
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "journee.details[facturable.id]"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    ]
                                                  : _c("InputNumber", {
                                                      class: {
                                                        parDefaut:
                                                          journee.id === 0 &&
                                                          !journee.effectifModifie,
                                                        nombreModifie:
                                                          journee.effectifModifie,
                                                        inputEffectif: true
                                                      },
                                                      attrs: {
                                                        typeFiltre:
                                                          "quantiteEntiere",
                                                        "data-key": journee.key,
                                                        disabled:
                                                          _vm.enEnregistrement ||
                                                          _vm.enChargement ||
                                                          !ligne.structure.actif
                                                      },
                                                      on: {
                                                        move: function($event) {
                                                          return _vm.moveEffectif(
                                                            $event,
                                                            iLigne,
                                                            iJournee
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.inputEffectif(
                                                            $event,
                                                            ligne,
                                                            journee
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: journee.effectif,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            journee,
                                                            "effectif",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "journee.effectif"
                                                      }
                                                    })
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    })
                                  ],
                                  2
                                )
                              })
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "i",
      {
        staticClass: "fas fa-users containerGereParMenu",
        attrs: {
          title:
            "Géré par le menu (le bouton 'Appliquer sur les menus' ne modifiera pas les effectifs du menu)"
        }
      },
      [_c("i", { staticClass: "fas fa-ban nestedGereParMenu" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }